
import abi from "./contract/GlobalPool.json";

import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import jQuery from "jquery";
import "./css/style.css";
import "./css/bootstrap.min.css";

import "./logo.png";
import "./Global.gif";
import "./2.png";
import "./3.png";
import "./4.png";
import "./5.png";
import "./6.png";
import "./7.png";
import "./8.png";
import "./9.png";
import "./10.png";
import "./copy.png";


import { useState, useEffect } from "react";
import { ethers } from "ethers";

function App() {

  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[auto,setAuto]=useState("None");
  const [tt1,settt1]=useState("None");
  const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
  const[l1,setl1]=useState("None");
  const[l2,setl2]=useState("None");
  const[l3,setl3]=useState("None");
  const[l4,setl4]=useState("None");
  const[l5,setl5]=useState("None");
  const[l6,setl6]=useState("None");
  const[l7,setl7]=useState("None");
  const[l8,setl8]=useState("None");
  const[l9,setl9]=useState("None");
  const[l10,setl10]=useState("None");
  const[l11,setl11]=useState("None");
  const[l12,setl12]=useState("None");
  const[l13,setl13]=useState("None");
  const[l14,setl14]=useState("None");
  const[l15,setl15]=useState("None");
  const[l16,setl16]=useState("None");
  const[l17,setl17]=useState("None");
  const[l18,setl18]=useState("None");
  const[l19,setl19]=useState("None");
  const[l20,setl20]=useState("None");
  const[l21,setl21]=useState("None");
  const[l22,setl22]=useState("None");
  const[l23,setl23]=useState("None");
  const[l24,setl24]=useState("None");
  const[l25,setl25]=useState("None");
  const[l26,setl26]=useState("None");
  const[l27,setl27]=useState("None");
  const[auto1,setAuto1]=useState("None");
  const[auto2,setAuto2]=useState("None");
  const[auto3,setAuto3]=useState("None");
  const[auto4,setAuto4]=useState("None");
  const[auto5,setAuto5]=useState("None");
  const[auto6,setAuto6]=useState("None");
  const[auto7,setAuto7]=useState("None");
    const[auto8,setAuto8]=useState("None");
  const[bonus,setBonus]=useState("None");
  const[bonus1,setBonus1]=useState("None");
  const[pack,setpackage]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [total,setTotal]=useState("None");
const [req,setreq]=useState("None");
const [tt,settt]=useState("None");
const[dd,setDD]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[bonanza1,setBonanza1]=useState("None");

const[wid,setwid]=useState("None");


  useEffect(() => {
    const connectWallet = async () => {
      const contractAddress = "0x25dc17ed7aca4259880721cc6d8cbaac5476ed2e";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
      const myParam = searchParams.get('ref');
      console.log(myParam);
      
      
      document.querySelector("#name").value=myParam;
  if(myParam == null)
  {
    document.querySelector("#name").value="0x7f6790B4885aac01d9862655bFE58B4aDFD59Fe1";
  }
      try {
        const { ethereum } = window;
      
        if (ethereum) {
          const account = await ethereum.request({
            method: "eth_requestAccounts",
           
          });
         
          window.ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          window.ethereum.on("accountsChanged", () => {
            
            window.location.reload();
          });

          const provider = new ethers.providers.Web3Provider(ethereum);
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
          let alltasks = await contract.getMemos(account[0]);
          setTasks(alltasks);
          let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);
          const b =Number(alltasks[2]);
          const refer = (alltasks[1]);
         setrefer(refer);
         document.querySelector("#hid").value  = (alltasks[1]);
         const direct =Number(alltasks[2]);
         setDirect(direct);
         const directs =  Number(alltasks[7])/1000000000000000000;
         setDirects(directs);
         const level = Number(alltasks[3])/1000000000000000000;
         setLevel(level);
         const auto = Number(alltasks[35])/1000000000000000000;
         setAuto(auto);
         const auto1 = Number(alltasks[36])/1000000000000000000;
         setAuto1(auto1);
        
         
         const auto3 = Number(alltasks[34])/1000000000000000000;
         setAuto3(auto3);
         
        


         const l2 = Number(alltasks[9]);
         setl2(l2);
         const l3 = Number(alltasks[10]);
         setl3(l3);
         const l4 = Number(alltasks[11]);
         setl4(l4);
         const l5 = Number(alltasks[12]);
         setl5(l5);
         const l6 = Number(alltasks[13]);
         setl6(l6);
         const l7 = Number(alltasks[14]);
         setl7(l7);
         const l8 = Number(alltasks[15]);
         setl8(l8);
         const l9 = Number(alltasks[16]);
         setl9(l9);
         const l10 = Number(alltasks[17]);
         setl10(l10);
         
const l11 = Number(alltasks[18]);
         setl11(l11);
         const l12 = Number(alltasks[19]);
         setl12(l12);
         const l13 = Number(alltasks[20]);
         setl13(l13);
         const l14 = Number(alltasks[21]);
         setl14(l14);
         const l15 = Number(alltasks[22]);
         setl15(l15);
         const l16 = Number(alltasks[23]);
         setl16(l16);
         const l17 = Number(alltasks[24]);
         setl17(l17);
         const l18 = Number(alltasks[25]);
         setl18(l18);
         const l19 = Number(alltasks[26]);
         setl19(l19);
         const l20 = Number(alltasks[27]);
         setl20(l20);
          const l21 = Number(alltasks[28]);
         setl21(l21);
                  const l22 = Number(alltasks[29]);
         setl22(l22);
         const l23 = Number(alltasks[30]);
         setl23(l23);
         const l24 = Number(alltasks[31]);
         setl24(l24);
         const l25 = Number(alltasks[32]);
         setl25(l25);
          const l26 = Number(alltasks[33]);
         setl26(l26);

          const l27 = l2 + l3 + l4 + l5 + l6 + l7 + l8 + l9 + l10 + l11 + l12 + l13 + l14 + l15 + l16 + l17 + l18 + l19 + l20 + l21 + l22 + l23 + l24 + l25 + l26;
         setl27(l27);
         
         
         const bonus = Number(alltasks[34])/1000000000000000000;
         setBonus(bonus);
         const bonus1 = Number(alltasks[21]);
         setBonus1(bonus1);
         const total = Number(alltasks[10]);
         setTotal(total);

         const tt = Number(alltasks[8])/1000000000000000000;
         settt(tt);
          const auto2 = tt - auto1;
         setAuto2(auto2);
         const pack = Number(alltasks[4]);
         document.querySelector("#pp").value  = Number(alltasks[4]);
         
    
    setpackage(pack);
    const bonanza = Number(alltasks[7]);
         setBonanza(bonanza);
         const bonanza1 = Number(alltasks[20]);
         setBonanza1(bonanza1);
    const dd = Number(alltasks[5]);
    setDD(dd);
    const dd1 =  Date.now() / 1000;
     setDD1(dd1);


     const tt1 = Math.trunc((dd1 - dd) / (3600 * 24 )) ;

       
     settt1(tt1);
         setB(b);
         const referlink = 'https://bvtpro.com/?ref='+ account;
         setreflink(referlink);
         document.querySelector("#link").value =referlink;
         const auto8 = Number(alltasks[0]);
         setAuto8(auto8);
     const auto4 = Number(alltasks1[0]);
         setAuto4(auto4);
         const auto5 = Number(alltasks1[1]);
         setAuto5(auto5);
         const auto6 = Number(alltasks1[2]);
         setAuto6(auto6);
         const auto7 = Math.trunc(Number(alltasks1[1])/3);
         setAuto7(auto7);
    
    console.log(pack);
    
     
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
     
    
    
    connectWallet();
    
  }, []);

 
  // console.log(state);
        
       
  return (
   
<div className="bg-slate-950 min-h-screen"> 
<input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="nn"></input>

    

      <section
      class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-24 px-6"
    >
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
          
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                
                Total Pool Joinings
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold">  {auto5}</h3>
            </div>
          </div>
          
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
              Total Pool Chain
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold"> {auto6}</h3>
            </div>
          </div>
        
        </div>
      </div>

       <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
          
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                My ID Number
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold">  {auto8}</h3>
              <br></br>
               <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Joined Since {tt1} Days
              </p>
            </div>
          </div>
          
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
              Total ID's Cleared
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold"> {auto7}</h3>
            </div>
          </div>
        
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Start Now
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> <Buy state={state} /></h3>
            </div>
          </div>
        
        </div>
      </div>

     
       <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"><input type ="text" style={{backgroundColor: "#fff" ,color:"black" ,padding:"1.5rem", textAlign:"center", border :"0" ,width:"80%"} }id ="test"></input></h3>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"> <Buy1 state={state} /></h3>
            </div>
          </div>
         
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                My Packages
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">  USDT {pack} </h3>
            </div>
          </div>
         
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 My Direct Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {direct}</h3>
            </div>
          </div>
          
        </div>
      </div>

<div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 My Level Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {l27}</h3>
            </div>
          </div>
          
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-cyan-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Income
              </p>
              
            </div>
          </div>
          <div class="space-y-4">
            <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
              <span class="text-slate-400 text-sm"></span>
              <span class="text-blue-400 font-mono text-sm font-bold"></span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"> My Direct Income</span>
              <span class="text-cyan-400 text-xs">USDT {directs}</span>
            </div>
            <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"> Level Income</span>
              <span class="text-cyan-400 text-xs">USDT {level}</span>
            </div>
              <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold">My Pool Income</span>
              <span class="text-cyan-400 text-xs">  USDT {auto}</span>
            </div>
              <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"> My Total Income</span>
              <span class="text-cyan-400 text-xs">USDT {tt}</span>
            </div>
             <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"> Pending Income</span>
              <span class="text-cyan-400 text-xs"> USDT {auto2}</span>
            </div>
             <div class="flex justify-between items-center pt-1">
              <span class="text-slate-200 font-bold"></span>
              <span class="text-cyan-400 text-xs"></span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 1 Team
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"> {direct}</h3>
            </div>
          </div>
          <div class="space-y-4">
           
           
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 2 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">{l2}</h3>
            </div>
          </div>
          <div class="space-y-4">
            
            
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 3 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {l3}</h3>
            </div>
          </div>
          <div class="space-y-4">
          
          
          
          </div>
        </div>
      </div>

    
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 4 Team
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"> {l4}</h3>
            </div>
          </div>
        
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Level 5 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">{l5}</h3>
            </div>
          </div>

        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 6 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {l6}</h3>
            </div>
          </div>
          
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 7 Team
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold">  {l7}</h3>
            </div>
          </div>
          <div class="space-y-4">
           
           
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 8 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">{l8}</h3>
            </div>
          </div>
          <div class="space-y-4">
            
            
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 9 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {l9}</h3>
            </div>
          </div>
          <div class="space-y-4">
          
          
          
          </div>
        </div>
      </div>

    
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 10 Team
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"> {l10}</h3>
            </div>
          </div>
        
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Level 11 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">{l11}</h3>
            </div>
          </div>

        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 12 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {l12}</h3>
            </div>
          </div>
          
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 13 Team
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"> {l13}</h3>
            </div>
          </div>
          <div class="space-y-4">
           
           
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 14 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">{l14}</h3>
            </div>
          </div>
          <div class="space-y-4">
            
            
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 15 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {l15}</h3>
            </div>
          </div>
          <div class="space-y-4">
          
          
          
          </div>
        </div>
      </div>

    
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 16 Team
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"> {l16}</h3>
            </div>
          </div>
        
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Level 17 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">{l17}</h3>
            </div>
          </div>

        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 18 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {l18}</h3>
            </div>
          </div>
          
        </div>
      </div>
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 19 Team
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"> {l19}</h3>
            </div>
          </div>
          <div class="space-y-4">
           
           
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 20 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">{l20}</h3>
            </div>
          </div>
          <div class="space-y-4">
            
            
          </div>
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                 Level 21 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {l21}</h3>
            </div>
          </div>
          <div class="space-y-4">
          
          
          
          </div>
        </div>
      </div>

    
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 22 Team
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"> {l22}</h3>
            </div>
          </div>
        
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
               Level 23 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">{l23}</h3>
            </div>
          </div>

        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 24 Team
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold"> {l24}</h3>
            </div>
          </div>
          
        </div>
      </div>
      
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Level 25 Team
              </p>
              <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold"> {l25}</h3>
            </div>
          </div>
        
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
              Total Withdraw
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold"> {auto1}</h3>
            </div>
          </div>
        
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
           
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-pink-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Connected Account  :
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-lg font-bold">{account} </h3>
            </div>
          </div>
         
        </div>
      </div>

      
      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
           <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
            <div>
              <p style={{fontSize:"2rem"}}
                class="text-blue-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                Refer Link
              </p>
                <h3  style={{fontSize:"1.8rem"}} class="text-white text-lg font-bold">{referlink}</h3>
    <p  className="text-base lg:text-lg font-bold">
    <button onClick={() => navigator.clipboard.writeText(referlink)}>
  <img
    src="copy.png"
    style={{ height: "35px", width: "35px", cursor: "pointer" }}
  />
</button>
    </p>
            
            </div>
          </div>
         
        </div>
      </div>

      <div
        class="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300"
      >
        <div class="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div class="flex items-center gap-3 mb-6">
              <div
              class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]"
            >
              <span class="text-white font-bold"></span>
            </div>
          
            <div>
              <p  style={{fontSize:"2rem"}}
                class="text-purple-400 text-[1rem] font-bold uppercase tracking-widest"
              >
                My Refer
              </p>
              <h3 style={{fontSize:"2rem"}} class="text-white text-xl font-bold">  {refer}</h3>
            </div>
          </div>
         
        </div>
      </div>

     

   
    </section>
                
    </div>                      
    


  );
}

export default App;
